import { Modal } from "antd";
import React from "react";

const CustomAntdModal = ({ open, onCancel, title, description, children, ...props }) => (
    <div className="d-flex justify-content-center gap-2">
        <Modal
            getContainer={false}
            open={open}
            onCancel={onCancel}
            footer={
                <div className="d-flex flex-column gap-2">
                    {/* Cada child vai ocupar um row */}
                    {React.Children.map(children, (child, idx) =>
                        child
                            ? <div key={idx} className="w-100">{child}</div>
                            : null
                    )}
                </div>
            }
            centered
            title={
                <h2 style={{ fontSize: 20 }}>
                    {title}
                </h2>
            }
            {...props}
            width={500}
        >
            <p style={{ fontSize: 16 }}>
                {description}
            </p>
        </Modal>
    </div>
);

export default CustomAntdModal;
